export default __webpack_public_path__ + "static/media/Maor-Booklet-Eng.c2f62d4c.pdf";